"use strict";

import { authConstants } from "../_constants";

export const loginAuthRequest = (payload) => {
  return {
    type: authConstants.AUTH_LOGIN_REQUEST,
    payload,
  };
};

export const loginUserNameFEBAStore = (payload) => {
  return {
    type: authConstants.AUTH_LOGIN_FEBA_USER_NAME_STORE,
    payload,
  };
};

export const loginAuthComplete = (payload, userDetails = null) => {
  if (userDetails != null && userDetails?.publicKey) {
    localStorage.setItem("publicKey", userDetails?.publicKey);
  }

  return {
    type: authConstants.AUTH_LOGIN_COMPLETE,
    payload,
  };
};

export const logoutAuthRequest = (payload) => {
  return {
    type: authConstants.AUTH_LOGOUT_REQUEST,
    payload,
  };
};

export const logoutAuthComplete = (payload) => {
  return {
    type: authConstants.AUTH_LOGOUT_COMPLETE,
    payload,
  };
};

export const idleTimeoutRequest = (payload) => {
  return {
    type: authConstants.IDLE_TIMEOUT_LOGOUT_REQUEST,
    payload,
  };
};

export const idleTimeoutComplete = (payload) => {
  return {
    type: authConstants.IDLE_TIMEOUT_COMPLETE,
    payload,
  };
};

export const otpConfirmRequest = (payload) => {
  return {
    type: authConstants.OTP_CONFIRM_REQUEST,
    payload,
  };
};

export const otpConfirmComplete = (payload) => {
  return {
    type: authConstants.OTP_CONFIRM_COMPLETE,
    payload,
  };
};

export const otpResendRequest = (payload) => {
  return {
    type: authConstants.OTP_RESEND_REQUEST,
    payload,
  };
};

export const otpResendComplete = (payload) => {
  return {
    type: authConstants.OTP_RESEND_COMPLETE,
    payload,
  };
};

export const authReducerInitiate = () => {
  return {
    type: authConstants.AUTH_REDUCER_INITIATE,
  };
};

export const setMultipleTabOpen = (payload) => {
  return {
    type: authConstants.SET_MULTIPLE_TAB_OPEN,
    payload,
  };
};

export const expiredPasswordChangeValueRequest = (payload) => {
  return {
    type: authConstants.EXPIRED_PASSWORD_CHANGE_VALUE_REQUEST,
    payload,
  };
};

export const expiredPasswordChangeValueComplete = (payload) => {
  return {
    type: authConstants.EXPIRED_PASSWORD_CHANGE_VALUE_COMPLETE,
    payload,
  };
};

export const expiredPasswordChangeValueError = (payload) => {
  return {
    type: authConstants.EXPIRED_PASSWORD_CHANGE_VALUE_ERROR,
    payload,
  };
};

export const clearReducer = () => {
  return {
    type: authConstants.AUTH_CLEAR_STORE,
  };
};

/**
 * key pair generation
 */

export const keyGenerationRequest = (payload) => {
  return {
    type: authConstants.KEY_GENERATION_REQUEST,
    payload,
  };
};

export const keyGenerationComplete = (payload) => {
  localStorage.setItem("publicKey", payload.data.publicKey);
  return {
    type: authConstants.KEY_GENERATION_COMPLETE,
  };
};

export const regenerateKey = () => {
  return {
    type: authConstants.KEY_REGENERATION,
  };
};
/**
 * End key pair generation
 */

export const payloadEncryptionSuccess = (
  encryptedPayload,
  originalPayload,
  callback = null,
) => {
  return {
    payload: originalPayload,
    encryptedPayload: encryptedPayload,
    callback,
  };
};

export const payloadEncryptionFail = (payload) => {
  return {
    payload,
  };
};

export const forgotUsernameValidateRequest = (payload) => {
  return {
    type: authConstants.FORGOT_USERNAME_VALIDATE_REQUEST,
    payload,
  };
};

export const forgotUsernameValidateComplete = (payload) => {
  return {
    type: authConstants.FORGOT_USERNAME_VALIDATE_COMPLETE,
    payload,
  };
};

export const forgotUsernameValidateError = (payload) => {
  return {
    type: authConstants.FORGOT_USERNAME_VALIDATE_ERROR,
    payload,
  };
};

export const forgotUsernameOTPConfirmRequest = (payload) => {
  return {
    type: authConstants.FORGOT_USERNAME_OTP_CONFIRM_REQUEST,
    payload,
  };
};

export const forgotUsernameOTPConfirmComplete = (payload) => {
  return {
    type: authConstants.FORGOT_USERNAME_OTP_CONFIRM_COMPLETE,
    payload,
  };
};

export const forgotUsernameOTPConfirmError = (payload) => {
  return {
    type: authConstants.FORGOT_USERNAME_OTP_CONFIRM_ERROR,
    payload,
  };
};

export const forgotUsernameOTPResendRequest = (payload) => {
  return {
    type: authConstants.FORGOT_USERNAME_OTP_RESEND_REQUEST,
    payload,
  };
};

export const forgotUsernameOTPResendComplete = (payload) => {
  return {
    type: authConstants.FORGOT_USERNAME_OTP_RESEND_COMPLETE,
    payload,
  };
};

export const forgotUsernameOTPResendError = (payload) => {
  return {
    type: authConstants.FORGOT_USERNAME_OTP_RESEND_ERROR,
    payload,
  };
};

export const CSRFTokenGenRequest = (payload) => {
  return {
    type: authConstants.CSRF_TOKEN_GEN_REQUEST,
    payload,
  };
};

export const CSRFTokenGenComplete = (payload) => {
  return {
    type: authConstants.CSRF_TOKEN_GEN_COMPLETE,
    payload,
  };
};

export const CSRFTokenGenError = (payload) => {
  return {
    type: authConstants.CSRF_TOKEN_GEN_ERROR,
    payload,
  };
};

export const changeLanguageRequest = (payload) => {
  return {
    type: authConstants.CHANGE_LANGUAGE_REQUEST,
    payload,
  };
};

export const changeLanguageComplete = (payload) => {
  return {
    type: authConstants.CHANGE_LANGUAGE_COMPLETE,
    payload,
  };
};

export const changeLanguageSuccessAlertHide = (payload) => {
  return {
    type: authConstants.CHANGE_LANGUAGE_SUCCESS_ALERT_HIDE,
    payload,
  };
};

export const forgotPasswordValidateRequest = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_VALIDATE_REQUEST,
    payload,
  };
};

export const forgotPasswordValidateComplete = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_VALIDATE_COMPLETE,
    payload,
  };
};

export const forgotPasswordValidateError = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_VALIDATE_ERROR,
    payload,
  };
};

export const forgotPasswordOTPConfirmRequest = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_OTP_CONFIRM_REQUEST,
    payload,
  };
};

export const forgotPasswordOTPConfirmComplete = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_OTP_CONFIRM_COMPLETE,
    payload,
  };
};

export const forgotPasswordOTPConfirmError = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_OTP_CONFIRM_ERROR,
    payload,
  };
};

export const forgotPasswordOTPResendRequest = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_OTP_RESEND_REQUEST,
    payload,
  };
};

export const forgotPasswordOTPResendComplete = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_OTP_RESEND_COMPLETE,
    payload,
  };
};

export const forgotPasswordOTPResendError = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_OTP_RESEND_ERROR,
    payload,
  };
};

//account confirm
export const forgotPasswordAccountConfirmRequest = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_ACCOUNT_CONFIRM_REQUEST,
    payload,
  };
};

export const forgotPasswordAccountConfirmComplete = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_ACCOUNT_CONFIRM_COMPLETE,
    payload,
  };
};

export const forgotPasswordAccountConfirmError = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_ACCOUNT_CONFIRM_ERROR,
    payload,
  };
};

//change value
export const forgotPasswordChangeValueRequest = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_CHANGE_VALUE_REQUEST,
    payload,
  };
};

export const forgotPasswordChangeValueComplete = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_CHANGE_VALUE_COMPLETE,
    payload,
  };
};

export const forgotPasswordChangeValueError = (payload) => {
  return {
    type: authConstants.FORGOT_PASSWORD_CHANGE_VALUE_ERROR,
    payload,
  };
};

//admin password
export const setAdminPasswordResetStatus = (payload) => {
  return {
    type: authConstants.SET_ADMIN_PASSWORD_RESET_STATUS,
    payload,
  };
};

export const setForgotPasswordScreenType = (screenType) => {
  return {
    type: authConstants.SET_FORGOT_PASSWORD_SCREEN_TYPE,
    payload: screenType,
  };
};

export const setForgotPasswordFormData = (data) => ({
  type: authConstants.SET_FORGOT_PASSWORD_FORM_DATA,
  payload: data,
});

export const setTabType = (tabType) => ({
  type: authConstants.SET_CARD_TAB_SCREEN,
  payload: tabType,
});

export const clearForgotDetails = (payload) => {
  return {
    type: authConstants.CLEAR_FORGOT_PASSWORD_DETAILS,
    payload,
  };
};

export const setForgotUsernameMessage = (payload) => ({
  type: authConstants.SET_FORGOT_USERNAME_MESSAGE,
  payload,
});
